var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCkLogoBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.531,
    height: 25.601,
    viewBox: "0 0 42.531 25.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1474",
    "data-name": "Group 1474",
    transform: "translate(-8544 -13473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    "data-name": "Path 6645",
    d: "M1117.38,1853.4h25.355l-12.651,12.8,12.651,12.8H1117.38Z",
    transform: "translate(7426.62 11619.6)",
    fill: "#223d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6646",
    "data-name": "Path 6646",
    d: "M1154.942,1853.4l-12.662,12.8,12.662,12.8h12.641l-12.683-12.869,12.683-12.731Z",
    transform: "translate(7418.949 11619.6)",
    fill: "#223d57"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCkLogoBlueIcon);
export default __webpack_public_path__ + "static/media/CK_logo_blue_icon.e69c8b8258911eaf6dc5d2d70a3de977.svg";
export { ForwardRef as ReactComponent };